import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import initialState from 'reducers/initialState';

export default function validationReducer(state = initialState.currentOffer.clientVerificationsData, action) {
  switch (action.type) {
    case actionTypes.LOAD_PARTNER_VERIFICATIONS_SUCCEEDED: {
      const { partnerVerifications } = action.payload;
      const partnerId = partnerVerifications.partnerId;

      const verifications = {
        ...state.verifications,
        [partnerId]: {
          ...state.verifications[partnerId],
          partnerId,
          isLoaded: true
        }
      };

      return {
        ...state,
        verifications
      };
    }
    case actionTypes.LOAD_PARTNER_VERIFICATIONS_SUMMARY_SUCCEEDED: {
      const { verificationsSummary, partnerId } = action.payload;
      const verifications = {
        ...state.verifications,
        [partnerId]: {
          ...state.verifications[partnerId],
          isLoaded: state.verifications[partnerId]?.isLoaded || false,
          partnerId,
          summary: verificationsSummary,
          summaryLoaded: true
        }
      };

      return {
        ...state,
        verifications
      };
    }
    case eventTypes.OFFER_PARTNER_VERIFICATIONS_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      return {
        ...state,
        verifications: {
          ...state.verifications,
          [partnerId]: {
            partnerId,
            isLoaded: false,
            summaryLoaded: false
          }
        }
      };
    }

    case eventTypes.DOCUMENT_VERIFICATION_UPDATED: {
      const { verification } = action.event.eventBody;
      const partnerId = verification.entityId;

      return {
        ...state,
        verifications: {
          ...state.verifications,
          [partnerId]: {
            ...state.verifications[partnerId],
            partnerId,
            summaryLoaded: false,
            summary: null
          }
        }
      };
    }

    case eventTypes.DOCUMENT_VERIFICATION_STARTED: {
      const { verification } = action.event.eventBody;
      const partnerId = verification.entityId;

      return {
        ...state,
        verifications: {
          ...state.verifications,
          [partnerId]: {
            ...state.verifications[partnerId],
            partnerId,
            summaryLoaded: false,
            summary: null
          }
        }
      };
    }

    default:
      return state;
  }
}
